// extracted by mini-css-extract-plugin
export default {"header":"LocationsTable_header__QcFRT","title":"LocationsTable_title__Y5ACl"};